import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconViewReturn: React.FC<IconProps> = ({
  size = 15,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 12 15"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path
      d="M8.84766 0L8.95117 0.129883L11.333 3.1123L11.4082 3.20605V4.81934C11.4081 5.00956 11.2537 5.16406 11.0635 5.16406C10.8732 5.16405 10.7188 5.00956 10.7188 4.81934V3.67188H9.37109C8.80016 3.67187 8.33691 3.20863 8.33691 2.6377V0.689453H1.03418C0.844031 0.689454 0.689717 0.844092 0.689453 1.03418V13.0762C0.689453 13.2665 0.843868 13.4209 1.03418 13.4209H10.374C10.5643 13.4209 10.7188 13.2665 10.7188 13.0762V11.3311C10.719 11.141 10.8733 10.9863 11.0635 10.9863C11.2536 10.9863 11.4079 11.141 11.4082 11.3311V13.0762C11.4082 13.6471 10.945 14.1104 10.374 14.1104H1.03418C0.463243 14.1104 -4.61362e-08 13.6471 0 13.0762V1.03418C0.000264059 0.463468 0.463406 5.63258e-07 1.03418 0H8.84766ZM8.44238 11.6133C8.59463 11.6133 8.71875 11.7364 8.71875 11.8887C8.71875 12.0409 8.59463 12.1641 8.44238 12.1641H2.24023C2.08798 12.1641 1.96484 12.0409 1.96484 11.8887C1.96484 11.7364 2.08798 11.6133 2.24023 11.6133H8.44238ZM7.75391 10.2354C7.90605 10.2355 8.0293 10.3586 8.0293 10.5107C8.02906 10.6627 7.90591 10.786 7.75391 10.7861H2.24023C2.08813 10.7861 1.96508 10.6628 1.96484 10.5107C1.96484 10.3585 2.08798 10.2354 2.24023 10.2354H7.75391ZM8.44238 8.85645C8.5946 8.85645 8.71869 8.97964 8.71875 9.13184C8.71875 9.28409 8.59463 9.40723 8.44238 9.40723H2.24023C2.08798 9.40723 1.96484 9.28409 1.96484 9.13184C1.9649 8.97964 2.08802 8.85645 2.24023 8.85645H8.44238ZM9.02637 2.6377C9.02637 2.82801 9.18078 2.98242 9.37109 2.98242H10.3467L9.02637 1.3291V2.6377Z"
      fill="currentColor"
    />
    <path
      d="M2.81543 4.97534C2.81543 3.53638 3.86629 2.34601 5.24219 2.1228L4.95898 1.92847C4.8491 1.85349 4.81767 1.70105 4.88867 1.58862C4.96006 1.47615 5.10773 1.44616 5.21777 1.52124L5.93066 2.00757C6.05772 2.09445 6.09406 2.27011 6.01172 2.40015L5.50391 3.19995C5.43242 3.31208 5.28569 3.34232 5.17578 3.26733C5.06581 3.19223 5.0341 3.03993 5.10547 2.92749L5.26465 2.67749C4.18357 2.88496 3.36621 3.83381 3.36621 4.97534C3.36637 6.26845 4.41489 7.31698 5.70801 7.31714C7.00125 7.31714 8.04965 6.26855 8.0498 4.97534C8.0498 4.82309 8.17392 4.69897 8.32617 4.69897C8.47824 4.69919 8.60156 4.82322 8.60156 4.97534C8.60141 6.57305 7.30575 7.86792 5.70801 7.86792C4.1104 7.86776 2.81559 6.57295 2.81543 4.97534Z"
      fill="currentColor"
    />
  </svg>
);

export default IconViewReturn;
